<template>
  <div v-if="isLoading" id="hora-loading" style="direction: rtl" class="loading">
    <HoraLogo
      style="margin-top: 12rem"
      :with_text="false"
      :animated="true"
      :is_loading="true"
    ></HoraLogo>
  </div>
</template>

<script>
import HoraLogo from "../components/HoraLogo.vue";

export default {
  name: "Loading",
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    HoraLogo,
  },
  methods: {
    showLoading() {
      this.isLoading = true;
    },
    hideLoading() {
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.loading-spinner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}

.loading {
  left: 0px;
  top: 0px;
  right: 0px;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: rgba(255, 255, 255, 0.8);
}
</style>
